<template>
  <div class="main">
    <navbar-component :isOpen="isOpenData" @toggle="isOpenData = $event" />
    <div class="contained">
      <hamburger-navigation :items="navbarItems" :isOpen="isOpenData" @toggle="isOpenData = $event"/>
      <div class="main-container" :class="{ isOpen: isOpenData }" @click="closeMenuForSmallScreens()">
        <section class="section">
          <router-view class="container main-view"></router-view>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import NavbarComponent from '@/components/layout/navbar/NavbarComponent.vue'
  import HamburgerNavigation from '@/components/layout/navbar/HamburgerNavigation.vue'
  import { mapState, mapMutations } from 'vuex'
  const MENU_MAX_SCREEN_WIDTH = 1125

  export default {
    name: 'main-component',
    data () {
      return {
        contentHeight: null,
        isOpenData: false
      }
    },
    props: {
      navbarItems: {
        type: Array,
        required: true
      },
      isOpen: {
        default: false
      }
    },
    components: {
      NavbarComponent,
      HamburgerNavigation
    },
    computed: {
      ...mapState({
        messages: state => state.messageModule.messages
      })
    },
    methods: {
      ...mapMutations([
        'removeStateMessages'
      ]),
      closeMenuForSmallScreens () {
        if (document.documentElement.clientWidth <= MENU_MAX_SCREEN_WIDTH) {
          this.isOpenData = false
        }
      },
      // this resolves the different formats which a message can take
      // when coming from the backend and always returns a simple string
      extractMessage (message) {
        let msg = message.message
        if (msg) {
          if (Array.isArray(msg)) {
            return msg.join(',')
          } else {
            return this.extractMessage(msg)
          }
        }
        return message.toString()
      }
    },
    created () {
      this.isOpenData = this.isOpen
      this.$on('closeMenuForSmallScreens', this.closeMenuForSmallScreens)
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'setStateMessages' || mutation.type === 'setDefaultStateMessage') {
          let removed = []
          for (let message of this.messages) {
            message.message = this.$gettext(this.extractMessage(message))
            this.$snackbar.open(message)
            removed.push(message)
          }
          this.removeStateMessages(removed)
        }
      })
    }
  }
</script>

<style lang="sass">
  div.snackbar
    white-space: pre !important
</style>
